/* eslint-disable react-native/no-inline-styles */
import { spacing } from "app/shared/styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-native-paper";
import StepIndicator from "react-native-step-indicator";
import { Block } from "app/shared/components/blocks/block";
import { View } from "react-native";

interface StepProcessProps {
  steps?: Array<string>;
  currentSteps: number | undefined;
}

export const StepProcessUniversal = (props: StepProcessProps) => {
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  const { steps = [t("STEP_KHOI_TAO"), t("STEP_XAC_NHAN"), t("STEP_XAC_THUC"), t("STEP_KET_QUA")], currentSteps } = props;
  const stepsLength = steps.length;
  const isDesktop = useDesktopMediaQuery();
  if (typeof currentSteps === "undefined") {
    throw new Error("CurrentSteps must be input");
  }

  const customStyles = {
    stepIndicatorSize: 28,
    currentStepIndicatorSize: 28,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: colors.accent,
    stepStrokeWidth: 3,
    stepStrokeFinishedColor: colors.accent,
    stepStrokeUnFinishedColor: "#aaaaaa",
    separatorFinishedColor: colors.accent,
    separatorUnFinishedColor: "#aaaaaa",
    stepIndicatorFinishedColor: colors.accent,
    stepIndicatorUnFinishedColor: "#ffffff",
    stepIndicatorCurrentColor: currentSteps === Number(stepsLength) - 1 ? colors.accent : "#ffffff",
    stepIndicatorLabelFontSize: 13,
    currentStepIndicatorLabelFontSize: 13,
    stepIndicatorLabelCurrentColor: currentSteps === Number(stepsLength) - 1 ? colors.surface : colors.accent,
    stepIndicatorLabelFinishedColor: colors.surface,
    stepIndicatorLabelUnFinishedColor: "#aaaaaa",
    labelColor: colors.placeholder,
    labelSize: 13,
    labelFontFamily: fonts.regular.fontFamily,
    currentStepLabelColor: currentSteps === Number(stepsLength) - 1 ? colors.placeholder : colors.accent,
  };

  const onPressStepBar = (step: number) => {
    console.log("step", step);
    // if (step < currentSteps) {
    //   const distance = currentSteps - step;
    //   if (distance === 1) {
    //     goBack();
    //   } else {
    //     return;
    //   }
    // }
    // if (currentSteps === steps.length) {
    //   return;
    // }
    return;
  };

  return (
    <Block pv={spacing.huge}>
      <>
        <Block row>
          <Block w={isDesktop && currentSteps !== stepsLength - 1 ? 200 : 0} />
          <View style={{ flex: 1 }}>
            <StepIndicator
              onPress={onPressStepBar}
              stepCount={stepsLength}
              customStyles={customStyles}
              currentPosition={currentSteps}
              labels={steps}
            />
          </View>
        </Block>
      </>
    </Block>
  );
};
